export default class UpdateNovedad {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(idPersonal, idNovedad, novedad) {
    const payload = {
      fk_idTipoNovedad: novedad.fk_idCatTipoNovedad,
      detalleNovedad: novedad.descripcion,
      fecha: novedad.fecha,
    }

    return await this.#repository.update(idPersonal, idNovedad, payload)
  }
}
